import { useLocation } from 'react-router-dom';
import { useInterfaceMode } from '@/auth/InterfaceModeContext';
import { getFeatureGuide } from './featureGuides';

export default function PageGuide() {
  const { pathname } = useLocation();
  const { guided } = useInterfaceMode();
  const guide = getFeatureGuide(pathname);
  if (!guide || !guided) return null;
  return <details key={pathname} className="mb-4 rounded border p-3 text-sm" aria-label="本页输入输出说明">
    <summary className="cursor-pointer font-medium">{guide.title}：输入怎样影响结果？</summary>
    <dl className="mt-3 grid gap-3 md:grid-cols-2">
      <div><dt className="font-medium">1. 输入什么</dt><dd className="mt-1 text-zinc-600 dark:text-zinc-300">{guide.input}</dd></div>
      <div><dt className="font-medium">2. 为什么会得到这个结果</dt><dd className="mt-1 text-zinc-600 dark:text-zinc-300">{guide.mechanism}</dd></div>
      <div><dt className="font-medium">3. 输出代表什么</dt><dd className="mt-1 text-zinc-600 dark:text-zinc-300">{guide.output}</dd></div>
      <div><dt className="font-medium">4. 怎样核对与继续</dt><dd className="mt-1 text-zinc-600 dark:text-zinc-300">{guide.next}</dd></div>
    </dl>
    <p className="mt-3 border-t pt-2 text-zinc-600 dark:text-zinc-300"><strong>容易混淆：</strong>{guide.terms}</p>
  </details>;
}
